import type { BuildingDataSummaryTranslations } from "../../types/buildingDataSummary";

export const buildingDataSummary: BuildingDataSummaryTranslations = {
  title: "Hoone andmed",
  fieldsFilled: "{confirmed} / {total} välja kinnitatud",
  confirmed: "Kinnitatud",
  pending: "Ootel",
  empty: "Tühjad",
  conflicts: "Konfliktid",
  conflictSingular: "Konflikt",
  conflictRowOne: "{field}: vastuoluline väärtus — vaata üle",
  conflictRowMany: "{count} välja vastuoluliste väärtustega — vaata üle",
  emptyRow: "{count} välja täita",
  updated: "Uuendatud {time}",
  openSidebar: "Ava hoone andmed",
  emptyTitle: "Hoone andmeid veel pole",
  emptyHint: "Hoone atribuudid ilmuvad siia, kui dokumendid on töödeldud.",
};
